import { z } from "zod";

const accountActorSchema = z.object({
  organisasjonsnummer: z.number(),
  navn: z.string(),
});

export const accountInfoSchema = z.object({
  pid: z.string(),
  navn: z.string(),
  organisasjonsTilgang: accountActorSchema.nullable(),
});

export type AccountInfo = z.infer<typeof accountInfoSchema>;
export type AccountActorItem = z.infer<typeof accountActorSchema>;
